import React from "react";
import { iconProps } from "../Helper";

export const ImprovePromptIcon = ({ className }: iconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      className={className}
    >
      <mask
        id="mask0_6684_81548"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="24"
        height="24"
      >
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask="url(#mask0_6684_81548)">
        <path
          className={className}
          d="M5 19H6.2615L16.498 8.7635L15.2365 7.502L5 17.7385V19ZM3.5 20.5V17.1155L16.6905 3.93075C16.8417 3.79342 17.0086 3.68733 17.1913 3.6125C17.3741 3.5375 17.5658 3.5 17.7663 3.5C17.9668 3.5 18.1609 3.53558 18.3488 3.60675C18.5368 3.67792 18.7032 3.79108 18.848 3.94625L20.0693 5.18275C20.2244 5.32758 20.335 5.49425 20.401 5.68275C20.467 5.87125 20.5 6.05975 20.5 6.24825C20.5 6.44942 20.4657 6.64133 20.397 6.824C20.3283 7.00683 20.2191 7.17383 20.0693 7.325L6.8845 20.5H3.5ZM15.8562 8.14375L15.2365 7.502L16.498 8.7635L15.8562 8.14375Z"
          fill="white"
        />
        <path
          className={className}
          d="M5.5 1.5L6.65966 4.34034L9.5 5.5L6.65966 6.65966L5.5 9.5L4.34034 6.65966L1.5 5.5L4.34034 4.34034L5.5 1.5Z"
          fill="white"
        />
        <path
          className={className}
          d="M18.5 15.1614L19.4282 17.4348L19.4679 17.5321L19.5652 17.5718L21.8386 18.5L19.5652 19.4282L19.4679 19.4679L19.4282 19.5652L18.5 21.8386L17.5718 19.5652L17.5321 19.4679L17.4348 19.4282L15.1614 18.5L17.4348 17.5718L17.5321 17.5321L17.5718 17.4348L18.5 15.1614Z"
          fill="white"
        />
      </g>
    </svg>
  );
};
